import React from 'react';
import { AuthRoles } from "components/auth";

export const AccessControlConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/access_control`,
            component: React.lazy(() => import('./AccessControl'))
        }
    ]
};